import { useMutation, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerMembers } from "@/lib/query/core/invalidation";

type RemoveStoreMemberInput = {
  storeSlug: string;
  memberId: string;
};

export function useRemoveStoreMemberMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ memberId }: RemoveStoreMemberInput) =>
      apiJsonClient<void>(endpoints.seller.memberById(memberId), {
        method: "DELETE",
      }),
    onSuccess: async (_data, variables) => {
      await invalidateSellerMembers(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
